// Pressure gain vertex schema
// Passive pressure-boosting device with DP curve. Dual elevation.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema, PressureDropCurveSchema } from '../base/common';

export const PressureGainVertexSchema = BaseVertexSchema.extend({
  type: z.literal('pressure_gain'),
  inlet_elevation: ValueWithUnitSchema,
  outlet_elevation: ValueWithUnitSchema,
  pressure_drop_curve: PressureDropCurveSchema,
  /** Efficiency ratio 0–1 (optional; used to compute input power) */
  efficiency_ratio: z.number().min(0).max(1).optional(),
});

export type PressureGainVertex = z.infer<typeof PressureGainVertexSchema>;
